// NPM Package Imports
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
// Angular Services Imports
import { CpMarketplaceApiService } from './services/cp-marketplace-api.service';
import { CpPollerService } from './services/cp-poller.service';
import { SharedDataService } from './services/shared-data.service';
import { CpHttpInterceptor } from './services/utilities/cp-http.interceptor';
import { ErrorInterceptor } from './services/utilities/error.interceptor';
import { NgbDateCustomParserFormatter } from './services/dateInputParserFormatter.service';
import { CpLoaderService } from './services/cp-loader.service';
import { CpSigningUrlsService } from './services/cp-signing-urls.service';
import { SentryErrorHandlerService } from './services/sentry-error-handler.service';
import { RejectDocumentsService } from './services/reject-documents.service';
import { StateMachineActionsService } from './services/state-machine-actions.service';
import { CpDocumentationActionsService } from './services/cp-documentation-actions.service';
import { CpDocumentsHelperService } from './services/documents-helper.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    BrowserAnimationsModule,
    NgbModule,
    ToastrModule.forRoot({
      timeOut: 8000,
      positionClass: 'toast-top-center',
      closeButton: false,
      enableHtml: true
    })
  ],
  providers: [
    SharedDataService,
    CpMarketplaceApiService,
    CpPollerService,
    CpLoaderService,
    CpSigningUrlsService,
    RejectDocumentsService,
    StateMachineActionsService,
    CpDocumentationActionsService,
    CpDocumentsHelperService,
    { provide: ErrorHandler, useClass: SentryErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: CpHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
